export { default as blue } from './blue';
export { default as green } from './green';
export { default as neutral } from './neutral';
export { default as red } from './red';
export { default as yellow } from './yellow';
export var white = '#FFFFFF';
export var black = '#000000';
export var transparent = 'transparent';